import { defer, EMPTY, Observable, of } from 'rxjs';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EpicDeps } from '@wearejh/m2-pwa-engine/lib/types';
import { catchableUnauthenticated } from '@wearejh/m2-pwa-user/lib/utils/user.utils';
import { ApolloClient } from 'apollo-client';

import { TypeMap, Actions, CartMsg, CartItemUpdateParams } from '../cart.actions';
import { cartVariantAndId } from '../utils/stateObservables';
import { updateItem, updateItemVariables } from '../queries/__generated__/updateItem';
import updateItemMutation from '../queries/updateItem.graphql';

const name = 'Cart.ItemUpdate';
type Action = TypeMap[typeof name];

/**
 * update an item in the cart.
 *
 * @param action$
 * @param state$
 * @param deps
 */
export function cartItemUpdateEpic(action$: Observable<any>, state$: Observable<any>, deps: EpicDeps) {
    return action$.pipe(
        ofType<Actions, Action>(name),
        withLatestFrom(cartVariantAndId(state$)),
        mergeMap(([action, [, cartId]]) => {
            if (!cartId) return console.error('Cart id was missing'), EMPTY;
            const ajax$ = updateItemAjax(action.payload, cartId!, deps);
            return ajax$.pipe(
                mergeMap(() => {
                    return of(CartMsg('Cart.ItemUpdateSuccess'), CartMsg('Cart.Refresh', { force: true }));
                }),
                catchableUnauthenticated(({ error }) => {
                    return of(CartMsg('Cart.ItemUpdateError', error));
                }),
            );
        }),
    );
}

function updateItemAjax(params: CartItemUpdateParams[], cartId: string, deps: EpicDeps) {
    return defer(() => {
        return (deps.client as ApolloClient<any>).mutate<updateItem, updateItemVariables>({
            mutation: updateItemMutation,
            operationName: 'updateItem',
            variables: {
                input: {
                    cart_id: cartId,
                    cart_items: params.map((param) => {
                        return {
                            quantity: param.qty,
                            cart_item_id: param.itemId,
                        };
                    }),
                },
            },
        } as any);
    });
}
